export default __webpack_public_path__ + "search-overview-final-product-1200-1a519ba3240ee1971e720c9627700666.png";